import { render, staticRenderFns } from "./brandsApply.vue?vue&type=template&id=3b07ac20&"
import script from "./brandsApply.vue?vue&type=script&lang=js&"
export * from "./brandsApply.vue?vue&type=script&lang=js&"
import style0 from "./brandsApply.vue?vue&type=style&index=0&id=3b07ac20&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports